import React from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-fade-in" data-id="element-285">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-286" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] flex flex-col animate-scale-in" data-id="element-287">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-288">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-289">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-290">
            <X className="w-6 h-6 text-gray-500" data-id="element-291" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-292">
          <div className="prose prose-sm max-w-none" data-id="element-293">
            {content.split('\n\n').map((paragraph, index) => {
            // Check if it's a heading (all caps or starts with number)
            const isHeading = paragraph.match(/^[A-Z\s]+$/) || paragraph.match(/^\d+\.\s+[A-Z]/);
            const isSubheading = paragraph.match(/^[A-Z][a-z\s]+:$/);
            if (isHeading) {
              return <h3 key={index} className="text-lg font-bold text-gray-900 mt-6 mb-3" data-id="element-294">
                    {paragraph}
                  </h3>;
            }
            if (isSubheading) {
              return <h4 key={index} className="text-base font-semibold text-gray-800 mt-4 mb-2" data-id="element-295">
                    {paragraph}
                  </h4>;
            }
            return <p key={index} className="text-gray-700 leading-relaxed mb-4" data-id="element-296">
                  {paragraph}
                </p>;
          })}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200" data-id="element-297">
          <button onClick={onClose} className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-fuchsia-500 text-white font-semibold rounded-full hover:from-purple-700 hover:to-fuchsia-600 transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-298">
            Close
          </button>
        </div>
      </div>
    </div>;
}